@if (selectedRoute$ | async; as selectedRoute) {
  <div class="blade-header">
    <p class="title">{{ 'Line' | translate }} {{ selectedRoute.routeName }}</p>
    <p class="caption">{{ selectedRoute.tripsEndStop }}</p>
  </div>
  <div class="trip-table">
    <div class="table-header" >
      <div>Trip</div>
      <div>Time</div>
      <div>Destination</div>
    </div>
    <div class="table-body">
      @for (trip of selectedRoute.trips; track trip) {
        <div class="row">
          <input
            type="checkbox"
            [id]="trip.tripNumber"
            [checked]="trip.selected"
            (change)="onChangeSelectTrip(trip)" />
            {{trip.selected}}
            <div>{{ trip.tripNumber }}</div>
            <div>{{ trip.departureTime }} - {{ trip.arrivalTime }}</div>
            <div>{{ trip.endStop }}</div>
          </div>
        }
      </div>
    </div>
  }